module.exports = __webpack_public_path__ + "img/upload_sablon.9907f60a.svg";